import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { hitApi, dateFormatter } from "../../../components/commonAction";
import svg from "../../../components/svg";

export default function Affiliates({ pageTitle }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("");

    const load = () => {
        setLoading(true);
        const qs = filter ? `?status=${encodeURIComponent(filter)}` : "";
        hitApi({ url: `admin/affiliates${qs}`, method: "GET", data: {}, alert: false }, (resp) => {
            setLoading(false);
            if (resp?.status) setRows(resp.data?.affiliates || []);
        });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(load, [filter]);

    return (
        <div className="pxl_rightBar_assets">
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl-rb-header-wrap"><div className="pxl-headingTop"><h2 className="pxl-rb-header-heading">Affiliates {rows.length ? <span className="pxl-rb-header-count">({rows.length})</span> : null}</h2></div></div>

            <div className="pxl-panel">
                <div className="pxl-panel-header">
                    <select
                        style={{ width: "auto", padding: "6px 10px", borderRadius: 6, border: "1px solid #e3e7f0", fontSize: 13 }}
                        value={filter}
                        onChange={e => setFilter(e.target.value)}
                    >
                        <option value="">All</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="suspended">Suspended</option>
                    </select>
                </div>
                <div className="pxl-panel-body pxl-panel-body--flush">
                    {!loading && rows.length === 0 ? (
                        <div className="text-muted" style={{ padding: 24, textAlign: "center" }}>No affiliates.</div>
                    ) : (
                        <div className="pxl_table table-responsive">
                            <table className="pxl_table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Status</th>
                                        <th>Earnings</th>
                                        <th>Balance</th>
                                        <th style={{ textAlign: "left" }}>Joined</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <>
                                            {[0, 1, 2, 3, 4].map(i => (
                                                <tr key={i}>
                                                    <td>
                                                        <span className="pxl-sk" style={{ width: '60%', height: 13, display: 'block' }} />
                                                        <span className="pxl-sk" style={{ width: '45%', height: 10, display: 'block', marginTop: 4 }} />
                                                    </td>
                                                    <td><span className="pxl-sk" style={{ width: '50%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: 60, height: 22, borderRadius: 11, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: '40%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: '40%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: '55%', height: 13, display: 'block' }} /></td>
                                                    <td></td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : rows.map(r => (
                                        <tr key={r._id}>
                                            <td>
                                                <p style={{ margin: 0 }}><Link to={`/admin/affiliates/${r._id}`}>{r.user?.name || "(unknown)"}</Link></p>
                                                <p style={{ color: "#8a8fa6", fontSize: 12, margin: 0 }}>{r.user?.email}</p>
                                            </td>
                                            <td><p><code>{r.referralCode}</code></p></td>
                                            <td>
                                                {r.status === "approved"
                                                    ? <span className="pxl-pill pxl-pill--success">approved</span>
                                                    : r.status === "suspended"
                                                        ? <span className="pxl-pill pxl-pill--danger">suspended</span>
                                                        : <span className="pxl-pill pxl-pill--muted">pending</span>}
                                            </td>
                                            <td><p>${Number(r.totalEarnings || 0).toFixed(2)}</p></td>
                                            <td>
                                                <p style={{ color: Number(r.currentBalance) < 0 ? "#d04050" : undefined }}>
                                                    ${Number(r.currentBalance || 0).toFixed(2)}
                                                </p>
                                            </td>
                                            <td style={{ textAlign: "left" }}><p style={{ color: "#8a8fa6", fontSize: 12 }}>{dateFormatter(r.createdAt, "D MMM YYYY")}</p></td>
                                            <td>
                                                <div className="pxl-tbl-action-btn-group">
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>}>
                                                        <Link to={`/admin/affiliates/${r._id}`} className="pxl-tbl-action-btn">
                                                            {svg.app.table_view_icon}
                                                        </Link>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
